/** One inline segment within a hero title line. */
export type HeroTitleSegment =
  | { type: 'text'; value: string }
  | { type: 'highlight'; value: string };

export type HeroTitleLine = HeroTitleSegment[];

const HIGHLIGHT_RE = /\{\{([^}]+)\}\}/g;

/**
 * Parses hero title markup:
 * - Newlines → separate display lines (rendered with `<br />` between them)
 * - `{{word}}` → accent highlight span
 */
export function parseHeroTitleMarkup(title: string): HeroTitleLine[] {
  const trimmed = title.trim();
  if (!trimmed) return [];

  return title.split(/\r?\n/).map((line) => parseHeroTitleLine(line));
}

function parseHeroTitleLine(line: string): HeroTitleSegment[] {
  const segments: HeroTitleSegment[] = [];
  let lastIndex = 0;

  for (const match of line.matchAll(HIGHLIGHT_RE)) {
    const index = match.index ?? 0;
    if (index > lastIndex) {
      segments.push({ type: 'text', value: line.slice(lastIndex, index) });
    }
    const highlight = match[1]?.trim() ?? '';
    if (highlight) {
      segments.push({ type: 'highlight', value: highlight });
    }
    lastIndex = index + match[0].length;
  }

  if (lastIndex < line.length) {
    segments.push({ type: 'text', value: line.slice(lastIndex) });
  }

  if (segments.length === 0 && line.length > 0) {
    segments.push({ type: 'text', value: line });
  }

  return segments;
}
